import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=94cd2dac&scoped=true&"
import script from "./Overall.vue?vue&type=script&lang=js&"
export * from "./Overall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cd2dac",
  null
  
)

export default component.exports